module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/ig/ig-05-9dbe9f686a9aa1bdacbf0222aea115eb.jpg";